import React, { useMemo } from 'react';

import CartAddOnOption from 'components/features/Cart/CartSidebar/CartAddOnOption';
import { selectCartOrderOptions } from 'domains/cart_order_options';
import { useAppSelector } from 'utils/hooks';
import { formatPrice } from 'utils/common';

import type { OptionGroupAPIData } from 'domains/option_groups';

type CartAddOnOptionGroupProps = {
  group: OptionGroupAPIData;
};

function CartAddOnOptionGroup(props: CartAddOnOptionGroupProps) {
  const { group: addOnGroup } = props;

  const cartOrderOptions = useAppSelector(selectCartOrderOptions);
  // Can only currently save one order option
  const cartOrderOption = useMemo(
    () => cartOrderOptions && cartOrderOptions[0],
    [cartOrderOptions]
  );

  return (
    <div className="addon_option">
      <div className="title">
        <span className="addon-name">{addOnGroup.name}</span>
        {cartOrderOption && cartOrderOption.pricing && (
          <span className="price">{formatPrice(cartOrderOption.pricing.total)}</span>
        )}
      </div>
      <p className="desc">{addOnGroup.tooltip_description}</p>
      <ul className="select-list" id={addOnGroup.uid} data-id={addOnGroup.id}>
        {addOnGroup.options.map((addOnOption) => (
          <CartAddOnOption
            key={addOnOption.id}
            option={addOnOption}
            groupId={addOnGroup.id}
            cartOrderOption={cartOrderOption}
          />
        ))}
      </ul>
    </div>
  );
}

export default CartAddOnOptionGroup;
